import type { VariantProps } from 'class-variance-authority';

import { cva } from 'class-variance-authority';

export { default as ExclusivePropertiesSection } from './Section.vue';

// Title variants using CVA
export const titleVariants = cva(
	'flex items-center font-matter-sq text-[28px] font-light md:text-[40px]',
	{
		variants: {
			variant: {
				default: 'text-beige',
				alternative: 'text-white'
			}
		},
		defaultVariants: {
			variant: 'default'
		}
	}
);

export type ExclusivePropertiesSectionTitleVariants = VariantProps<
	typeof titleVariants
>['variant'];
